import { render, staticRenderFns } from "./select-sizhenshebei.vue?vue&type=template&id=67881ac3&scoped=true&"
import script from "./select-sizhenshebei.vue?vue&type=script&lang=ts&"
export * from "./select-sizhenshebei.vue?vue&type=script&lang=ts&"
import style0 from "./select-sizhenshebei.vue?vue&type=style&index=0&id=67881ac3&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67881ac3",
  null
  
)

export default component.exports